import {
  isAdminRead,
  getStrategyPermissions,
  getPortfolioPermissions,
  getProjectPerms, hasPermsOnIndexesOrReceipts
} from '../../services/rolesSvc';

export const getStratReportLinkVisibility = (userCtx, stratId) => {
  const stratPerms = getStrategyPermissions(userCtx, stratId);
  const stratPermsResult = stratPerms.canWrite || stratPerms.canRead;

  const isAssignedProject = userCtx && userCtx.perms.includes('projs');

  return isAdminRead(userCtx) || stratPermsResult || isAssignedProject;
};

export const getPortfolioBudgetLinkVisibility = (userCtx, stratId, portfolioId) => {
  const stratPerms = getStrategyPermissions(userCtx, stratId);
  const stratPermsResult = stratPerms.canWrite || stratPerms.canRead;

  const portfPerms = getPortfolioPermissions(userCtx, portfolioId);
  const portfPermsResult = portfPerms.canWrite || portfPerms.canRead;

  return isAdminRead(userCtx) || stratPermsResult || portfPermsResult;
};

export const getProjectReportLinkVisibility = (userCtx, stratId, portfolioId, projId) => {
  const projPerms = getProjectPerms(userCtx, projId, stratId, portfolioId);
  const indexesPerms = hasPermsOnIndexesOrReceipts(userCtx, { stratId, portfolioId, projId });
  return projPerms.canRead || projPerms.canWrite || indexesPerms
}
